module.exports = __webpack_public_path__ + "assets/img/pegi-en.c21598b0.png";